var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HeroImageNewCssComponent/HeroImage.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { Box, ThemeConstellation } from '@zillow/constellation';
export var HeroImage = function HeroImage(_ref) {
  var mobileImg = _ref.mobileImg,
      mobileImg2x = _ref.mobileImg2x,
      mobileWebp = _ref.mobileWebp,
      mobileWebp2x = _ref.mobileWebp2x,
      tabletPortraitImg = _ref.tabletPortraitImg,
      tabletPortraitImg2x = _ref.tabletPortraitImg2x,
      tabletPortraitWebp = _ref.tabletPortraitWebp,
      tabletPortraitWebp2x = _ref.tabletPortraitWebp2x,
      tabletLandscapeImg = _ref.tabletLandscapeImg,
      tabletLandscapeImg2x = _ref.tabletLandscapeImg2x,
      tabletLandscapeWebp = _ref.tabletLandscapeWebp,
      tabletLandscapeWebp2x = _ref.tabletLandscapeWebp2x,
      desktopImg = _ref.desktopImg,
      desktopImg2x = _ref.desktopImg2x,
      desktopWebp = _ref.desktopWebp,
      desktopWebp2x = _ref.desktopWebp2x,
      Head = _ref.Head;
  var media = {
    mobile: "(max-width: " + ThemeConstellation.constellation.breakpoints.sm + "px)",
    tabletPortrait: "(max-width: " + ThemeConstellation.constellation.breakpoints.lg + "px) and (min-width: " + ThemeConstellation.constellation.breakpoints.sm + "px)",
    tabletLandscape: "(max-width: " + ThemeConstellation.constellation.breakpoints.xxl + "px) and (min-width: " + ThemeConstellation.constellation.breakpoints.lg + "px)",
    desktop: "(min-width: " + ThemeConstellation.constellation.breakpoints.xxl + "px)"
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Head, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    media: media.mobile,
    imagesrcset: mobileWebp + " 1x, " + mobileWebp2x + " 2x",
    fetchPriority: "high",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    media: media.tabletPortrait,
    imagesrcset: tabletPortraitWebp + " 1x, " + tabletPortraitWebp2x + " 2x",
    fetchPriority: "high",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    media: media.tabletLandscape,
    imagesrcset: tabletLandscapeWebp + " 1x, " + tabletLandscapeWebp2x + " 2x",
    fetchPriority: "high",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preload",
    as: "image",
    media: media.desktop,
    imagesrcset: desktopWebp + " 1x, " + desktopWebp2x + " 2x",
    fetchPriority: "high",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement("picture", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("source", {
    media: media.mobile,
    srcSet: mobileWebp + " 1x, " + mobileWebp2x + " 2x",
    type: "image/webp",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.mobile,
    srcSet: mobileImg + " 1x, " + mobileImg2x + " 2x",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.tabletPortrait,
    srcSet: tabletPortraitWebp + " 1x, " + tabletPortraitWebp2x + " 2x",
    type: "image/webp",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.tabletPortrait,
    srcSet: tabletPortraitImg + " 1x, " + tabletPortraitImg2x + " 2x",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.tabletLandscape,
    srcSet: tabletLandscapeWebp + " 1x, " + tabletLandscapeWebp2x + " 2x",
    type: "image/webp",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.tabletLandscape,
    srcSet: tabletLandscapeImg + " 1x, " + tabletLandscapeImg2x + " 2x",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.desktop,
    srcSet: desktopWebp + " 1x, " + desktopWebp2x + " 2x",
    type: "image/webp",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("source", {
    media: media.desktop,
    srcSet: desktopImg + " 1x, " + desktopImg2x + " 2x",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(Box, {
    as: "img",
    alt: "",
    role: "presentation",
    src: desktopImg,
    sx: {
      pointerEvents: 'none',
      position: 'absolute',
      inset: '0px',
      objectFit: 'cover',
      width: '100%',
      height: '100%',
      objectPosition: 'center ',
      zIndex: -1
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 17
    }
  })));
};
HeroImage.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identifies mobile image media.
   */
  mobileImg: PropTypes.string.isRequired,

  /**
   * Identifies mobile image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg2x: PropTypes.string.isRequired,

  /**
   * Identifies mobile webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp: PropTypes.string.isRequired,

  /**
   * Identifies mobile webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp2x: PropTypes.string.isRequired,

  /**
   * Identifies tablet portrait image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg: PropTypes.string.isRequired,

  /**
   * Identifies tablet portrait image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg2x: PropTypes.string.isRequired,

  /**
   * Identifies tablet portrait webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp: PropTypes.string.isRequired,

  /**
   * Identifies tablet portrait webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp2x: PropTypes.string.isRequired,

  /**
   * Identifies tablet landscape image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg: PropTypes.string.isRequired,

  /**
   * Identifies tablet landscape image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg2x: PropTypes.string.isRequired,

  /**
   * Identifies tablet landscape webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp: PropTypes.string.isRequired,

  /**
   * Identifies tablet landscape webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp2x: PropTypes.string.isRequired,

  /**
   * Identifies desktop image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg: PropTypes.string.isRequired,

  /**
   * Identifies desktop image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg2x: PropTypes.string.isRequired,

  /**
   * Identifies desktop webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp: PropTypes.string.isRequired,

  /**
   * Identifies desktop webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp2x: PropTypes.string.isRequired,

  /**
   * Identifies the Head component from Next.js - if provided images are
   * preloaded.
   */
  Head: PropTypes.func
} : {};
HeroImage.defaultProps = {
  Head: function Head() {
    return null;
  }
};